import PropTypes from 'prop-types';
import { twMerge } from 'tailwind-merge';

import Text from 'shopper/components/Text';

import { formatAsBRLWithSignal } from 'lib/number';

import PriceTooltip from './PriceTooltip';
import Range from './Range';

const getDirection = (range) => {
  switch (range) {
    case 1:
      return 'left';
    case 2:
      return 'center';
    case 3:
      return 'right';
    default:
      return 'left';
  }
};

const PriceRanges = ({ className, offerPrice, minPrice, maxPrice, range }) => (
  <div className={twMerge('relative mt-2', className)}>
    <PriceTooltip direction={getDirection(range)} offerPrice={offerPrice} />
    <div className="mb-1 mt-10 flex gap-1 divide-x divide-neutral-high-400 dark:divide-neutral-low-100">
      <Range
        className="bg-rd-success-200 dark:bg-rd-success-200"
        direction="left"
        isActive={range === 1}
      />
      <Range
        className="bg-rd-warning-200 dark:bg-rd-warning-200"
        isActive={range === 2}
      />
      <Range
        className="bg-rd-error-100 dark:bg-rd-error-100"
        direction="right"
        isActive={range === 3}
      />
    </div>
    <div className="flex justify-between">
      <div>
        <Text
          className="mt-1 text-neutral-low-200 dark:text-neutral-high-400"
          size="size3"
        >
          Menor preço
        </Text>
        <Text
          className="text-neutral-low-200 dark:text-neutral-high-400"
          size="size3"
          bold
        >
          {formatAsBRLWithSignal(minPrice)}
        </Text>
      </div>
      <div>
        <Text
          className="mt-1 text-neutral-low-200 dark:text-neutral-high-400"
          size="size3"
        >
          Maior preço
        </Text>
        <Text
          className="text-end text-neutral-low-200 dark:text-neutral-high-400"
          size="size3"
          bold
        >
          {formatAsBRLWithSignal(maxPrice)}
        </Text>
      </div>
    </div>
  </div>
);

PriceRanges.propTypes = {
  className: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  offerPrice: PropTypes.number.isRequired,
  minPrice: PropTypes.number.isRequired,
  maxPrice: PropTypes.number.isRequired,
  range: PropTypes.number.isRequired,
};

export default PriceRanges;
